module.exports = __webpack_public_path__ + "img/img-2-mobile.d6fb56e5.png";